<template>
  <div class="new-sale-list">
    <div class="h-table h-table--w6 new-sale-list__table">
      <div class="h-table__thead">
        <div class="h-table__tr">
          <div class="h-table__th new-sale-list__table-th new-sale-list__table-th--cat"><b>Категория</b></div>
          <div class="h-table__th new-sale-list__table-th new-sale-list__table-th--product"><b>Товар</b></div>
          <div class="h-table__th new-sale-list__table-th new-sale-list__table-th--coating"><b>Покрытие</b></div>
          <div class="h-table__th new-sale-list__table-th new-sale-list__table-th--qty"><b>Кол-во</b></div>
          <div class="h-table__th new-sale-list__table-th new-sale-list__table-th--del"></div>
        </div>
      </div>
      <div class="h-table__tbody">
        <div class="h-table__tr new-sale-list__table-tr" v-for="p in list" :key="p.idx">
          <div class="h-table__td new-sale-list__table-td new-sale-list__table-td--cat">
            <div class="new-sale-list__table-td-header">Категория:</div>
            <div class="new-sale-list__table-td-content">{{p.category.name}}</div>
          </div>
          <div class="h-table__td new-sale-list__table-td new-sale-list__table-td--product">
            <div class="new-sale-list__table-td-header">Товар:</div>
            <div class="new-sale-list__table-td-content">{{p.product.name}}</div>
          </div>
          <div class="h-table__td new-sale-list__table-td new-sale-list__table-td--coating">
            <div class="new-sale-list__table-td-header">Покрытие:</div>
            <div class="new-sale-list__table-td-content">{{p.coating ? p.coating.name : '---'}}</div>
          </div>
          <div class="h-table__td new-sale-list__table-td new-sale-list__table-td--qty">
            <div class="new-sale-list__table-td-header">Количество:</div>
            <div class="new-sale-list__table-td-content">{{p.qty}}</div>
          </div>
          <div class="h-table__td new-sale-list__table-td new-sale-list__table-td--del">
            <div class="new-sale-list__table-td-header">Удалить:</div>
            <div class="new-sale-list__table-td-content text-right">
              <v-btn icon small color="error" @click="$emit('remove', p.idx)">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['list', 'isNewSale'],
  computed: {
    sum() {
      return (this.$props.list && this.$props.list.length)
        ? this.$props.list.reduce((acc, i) => acc + i.bonuses, 0)
        : 0;
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/variables";

  .new-sale-list {
    &__table-tr {
      @media (max-width: 600px) {
        border: 1px solid $sales-table-border-color;
        padding: 6px;
        margin-bottom: 30px;
      }

      &:last-child {
        .new-sale-list__table-td {
          @media (min-width: 600px) {
            border-bottom: 1px solid $sales-table-border-color;
          }
        }
      }
    }
    &__table-th {
      display: none;

      @media (min-width: 600px) {
        display: table-cell;
        padding: 4px;
      }

      &--qty {
        @media (min-width: 600px) {
          width: 100px;
        }
      }

      &--del {
        @media (min-width: 600px) {
          width: 50px;
        }
      }
    }
    &__table-td {
      border-top: 1px solid $sales-table-border-color;
      padding: 4px;

      @media (max-width: 600px) {
        display: flex;
        justify-content: space-between;
      }

      &--cat {
        @media (max-width: 600px) {
          border-top: none;
        }
      }
    }
    &__table-td-header {
      padding-right: 4px;

      @media (min-width: 600px) {
        display: none;
      }
    }
    &__table-td-item {
      border-bottom: 1px dotted $sales-table-border-color;
    }
    &__table-td-item-name {
      padding-right: 6px;
    }

    &__result {
      display: flex;
      justify-content: space-between;
    }
  }
</style>
